import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

interface MergeTagComponentProps {
  mergeTag: MergeTag;
}

const StyledTag = styled(Typography)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.light}`, // or use theme.palette.primary.light
  borderRadius: 4,
  backgroundColor: '#f0f8ff', // optional highlight, or theme.palette.action.hover
  margin: '0 1px',
  font: 'inherit',
  display: 'inline',
}));

export function MergeTagComponent({ mergeTag }: MergeTagComponentProps) {
  const exampleText = mergeTag.example ? ` (e.g. ${mergeTag.example})` : '';
  return (
    <Tooltip title={`${mergeTag.description}${exampleText}`} arrow>
      <StyledTag>{`{{${mergeTag.name}}}`}</StyledTag>
    </Tooltip>
  );
}

export default MergeTagComponent;
